import { get, post, put } from '../request'

export const getEstimateFieldByProject = (id, name, categories = [], pagination = { page: 1, pageSize: 5 }) =>
  get(`api/estimate-field/find/project/${id}`, { name, categories, pagination })
export const addEstimateField = (data) => post('api/estimate-field/createByOperator', { data })
export const updateEstimateField = (id, data) => put(`api/estimate-fields/${id}`, { data })
export const updateWithFile = (data) => post('api/estimate-field/updateWithFile', { data })
export const getEstimateFieldCategoryByProject = (estimateIds) =>
  get('api/estimate-field/category/find', { ids: estimateIds })
export const getEstimateFieldsByQuery = (id, query) => get(`api/estimate-field/find/query/${id}`, { query })
export const getEstimateFieldsByEmbedding = (id, query, subQuery) =>
  get(`api/estimate-field/embedding/query/${id}`, { query, subQuery })
